export default __webpack_public_path__ + "static/media/chardhampackage.c5ca6a2b.jpg";